export const filters = {
    'all': "",
    'requested': "requested",
    'open': "open",
    'on hold': "onHold",
    'in progress': "inProgress",
    'completed': "complete",
    'rejected': "declined"
};


export const statuses = {
    'open': "Open",
    'onHold': "On Hold",
    'inProgress': "In Progress",
    'complete': "Completed",
    'requesting': "Requested",
    'rejected': "Rejected",
};
